module.exports = __webpack_public_path__ + "img/2.eefaa6d6.png";